export const WEB_PUSH_MODAL_NAME = 'webPush'

// export enum WebPushModalAction {
//   'allow' = 'allow',
//   'dined' = 'dined',
// }
